import * as React from "react";
import classNames from "classnames";

import classes from "./CommonFullscreenHeader.styl";
import {Close} from "../controls/Close";



interface ICommonFullscreenHeaderProps {
    className?: string;
    align?: "start" | "end";
}

export const CommonFullscreenHeader: React.FC<ICommonFullscreenHeaderProps> = (props): React.ReactElement => {
    const align = props.align ?? "start";

    const headerCn = classNames(
        "clips-fullscreen__common-header",
        props.className,
        classes["common-fullscreen-header"],
        {
            [classes[`__align-${align}`]]: align
        }
    );


    return (
        <header className={headerCn}>
            <div className={classes["control__button"]}>
                <Close/>
            </div>
        </header>
    );
};
